import { render, staticRenderFns } from "./IconAgent.vue?vue&type=template&id=cdbc7df2&scoped=true&"
import script from "./IconAgent.vue?vue&type=script&lang=js&"
export * from "./IconAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbc7df2",
  null
  
)

export default component.exports